import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import { Icon } from '../../../../../components/common/icon/Icon';
import { JoinProcessPageWrapper } from '../JoinProcessPageWrapper';
import { DaumPostCodeModal } from '../../../../../components/custom/modal/popup/DaumPostCodeModal';
import { useAppDispatch } from '../../../../../hooks/store/useStore';
import { RegionHierarchy, userJoinSlice } from '../../../../../store/userJoinSlice';

export const JoinProcessRegionPage = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const userJoinActions = userJoinSlice.actions;

  const [isShowDaumPostCodeModal, setIsShowDaumPostCodeModal] = useState<boolean>(false);
  const [location, setLocation] = useState<string>('');
  const [regionHierarchy, setRegionHierarchy] = useState<RegionHierarchy>();

  return (
    <>
      <JoinProcessPageWrapper
        headerTitle={'회원님의 지역을 알려주세요'}
        canConfirm={location !== undefined && regionHierarchy !== undefined}
        confirmHandler={() => {
          if (!regionHierarchy) {
            return;
          }

          dispatch(userJoinActions.changeResidence(regionHierarchy));
          navigate('/join-process/job', { replace: true });
        }}
      >
        <RegionContainer>
          <RegionSection>
            <RegionHeader>
              <RegionHeaderText>{'입력된 지역'}</RegionHeaderText>
            </RegionHeader>
            <RegionContent>
              <RegionInfoContainer>
                {!location ? (
                  <>
                    <Icon name={'ExclamationMark'} width={20} height={20} />
                    <RegionInfoText>{'아직 위치 정보가 없습니다.'}</RegionInfoText>
                  </>
                ) : (
                  <>
                    <IconWrapper>
                      <Icon name={'RedCheck2'} width={13} height={10} />
                    </IconWrapper>
                    <RegionInfoText className="sensitive-text">{location}</RegionInfoText>
                  </>
                )}
              </RegionInfoContainer>
            </RegionContent>
          </RegionSection>

          <DaumPostCodeButton onClick={() => setIsShowDaumPostCodeModal(true)}>
            <Icon name={'BlueMarker'} width={20} height={20} />
            <DaumPostCodeButtonText>{'주소 찾기'}</DaumPostCodeButtonText>
          </DaumPostCodeButton>
        </RegionContainer>
      </JoinProcessPageWrapper>

      <DaumPostCodeModal
        shouldReturnAddressHierarchy
        isShow={isShowDaumPostCodeModal}
        onClose={() => setIsShowDaumPostCodeModal(false)}
        onSearchFinished={(searchedRegion: string, regionHierarchy?: RegionHierarchy) => {
          setLocation(searchedRegion);
          setRegionHierarchy(regionHierarchy);
        }}
      />
    </>
  );
};

const RegionContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 24px;
  align-self: stretch;
`;
const RegionSection = styled.div`
  width: 100%;

  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  gap: 16px;
`;

const RegionHeader = styled.div`
  width: 100%;

  display: flex;
  justify-content: flex-start;
  align-items: center;
`;

const RegionHeaderText = styled.span`
  color: var(--Light-Scheme-Monochrome-black, #232429);

  /* System/Medium/m-medium */
  font-family: Pretendard;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 85%; /* 11.9px */
`;

const RegionContent = styled.div`
  width: 100%;

  display: flex;
  justify-content: center;
  align-items: center;

  border-radius: var(--radius-none, 0px);
`;

const RegionInfoContainer = styled.div`
  width: 100%;
  display: flex;
  height: 40px;
  padding: 16px;
  align-items: center;
  gap: 8px;
  align-self: stretch;

  border-radius: var(--radius-medium, 8px);
  border: 1px solid var(--Light-Scheme-Monochrome-grey30, #e0e0eb);
`;

const RegionInfoText = styled.span`
  color: var(--Light-Scheme-Monochrome-black, #232429);
  text-align: center;

  /* Display/Large/l-regular */
  font-family: Pretendard;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 130%; /* 20.8px */
`;

const DaumPostCodeButton = styled.button`
  display: flex;
  max-height: 40px;
  padding: 16px;
  align-self: stretch;
  justify-content: center;
  align-items: center;
  gap: 4px;
  flex: 1 0 0;

  border-radius: var(--radius-medium, 8px);
  background: var(--Light-Scheme-Monochrome-grey10, #f2f2f7);
`;

const DaumPostCodeButtonText = styled.span`
  color: var(--Light-Scheme-Monochrome-black, #232429);

  /* System/Medium/m-medium */
  font-family: Pretendard;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 85%; /* 11.9px */
`;

const IconWrapper = styled.div`
  width: 20px;
  height: 20px;

  display: flex;
  justify-content: center;
  align-items: center;

  padding: 5px 3px 5px 4px;
`;
